import React from 'react'
import { Container } from 'react-bootstrap'
import { EmployerHeader } from '../Components/Header/EmployerHeader'
import { EmployerRightSide } from '../Components/RightSide/EmployerRightSide'
import classes from './EmployerLayout.module.css'
import 'bootstrap/dist/css/bootstrap.min.css';

interface Props{
    children: React.ReactNode
}

export const EmployerLayout: React.FC<Props> = (props)=>{
    
    
    return(
        <div className={classes.main}>
            <div className={classes.content}>
                <EmployerHeader />
                <div className={[classes.s_container, classes.page].join(' ')}>
                <Container style={{boxSizing: 'border-box'}}>
                    {props.children}
                </Container>
                </div>
            </div>
            <EmployerRightSide />
        </div>
)
}